import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['button', 'text', 'accessCode'];

  disableButton(e) {
    this.buttonTarget.disabled = 'disabled';

    if (this.textTarget.tagName === 'SPAN') {
      this.textTarget.innerHTML = 'Processing...';
    } else {
      this.textTarget.value = 'Processing...';
    }
  }

  onSubmit(e) {
    if (!this.hasAccessCodeTarget) {
      return;
    }

    const enqueueUrl = '/orders/enqueue_eway_payment_check';
    const csrfToken = document
      .querySelector('meta[name="csrf-token"]')
      ?.getAttribute('content');

    void fetch(enqueueUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(csrfToken ? { 'X-CSRF-Token': csrfToken } : {}),
      },
      body: JSON.stringify({ access_code: this.accessCodeTarget.value }),
    });
  }
}
